export default __webpack_public_path__ + "static/media/confirm_check_icon.08a10ed4.svg";